import { ReactSVG } from "react-svg";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Spinner from "../common/Spinner";
import Styled from "styled-components";
import logos from "views/resources/logos/SVG/";

const SocialButton = ({ icon, loading, onClick }) => {
	const logo =
		icon === "google"
			? logos.google
			: icon === "facebook"
			? logos.facebook
			: logos.outlook;

	return (
		<StyledButton onClick={onClick}>
			{loading ? (
				<Spinner color="#a2a2a2" button size={"medium"} />
			) : (
				<ReactSVG src={logo} />
			)}
		</StyledButton>
	);
};

SocialButton.propTypes = {
	icon: PropTypes.string,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
};

export default SocialButton;

const defaultColor = "#fefefe";
const fbColor = "#3c5a99";

const StyledButton = Styled.button`
		cursor: pointer;
		border-radius: 0.75rem;
		border: none;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
			0 2px 4px -1px rgba(0, 0, 0, 0.06);
		padding: 0.5em 1.5em;
		margin: 0 0.5em;
		background-color: ${({ icon }) =>
			icon === "facebook" ? fbColor : defaultColor};
		svg {
			width: auto;
			height: 30px;
		}
	`;
